import './grave.css';
import './edit-headstone.css';
import { mountTemplate } from './modal-base';
import { speciesOptionsHtml } from '../../utils/breeds';
import { t } from '../../i18n';
import { resetEditFormBindings } from '../../features/edit-headstone';

function buildEditHeadstoneTemplate(): string {
  return /* html */ `
<div class="modal-overlay" id="edit-headstone-modal" style="display:none;">
  <div class="modal-content grave-modal-content">
    <h3 style="margin-top:0; color:var(--color-text-primary);">${t('editHeadstone.title')}</h3>

    <input type="text" id="edit-name" placeholder="${t('grave.animalName')}" maxlength="30" required>

    <label class="grave-field-label" for="edit-species">${t('grave.speciesLabel')}</label>
    <select id="edit-species" class="grave-select">
      <option value="">${t('grave.speciesPlaceholder')}</option>
      ${speciesOptionsHtml()}
    </select>

    <div id="edit-species-other-wrap" style="display:none;">
      <input type="text" id="edit-species-other" placeholder="${t('grave.speciesOther')}" maxlength="80">
    </div>

    <input type="text" id="edit-breed" placeholder="${t('grave.breed')}" maxlength="80" autocomplete="off">

    <div class="grave-dates-row">
      <div>
        <label class="grave-field-label" for="edit-birth">${t('grave.birthDate')}</label>
        <input type="date" id="edit-birth" class="grave-date-input">
      </div>
      <div>
        <label class="grave-field-label" for="edit-death">${t('grave.deathDate')}</label>
        <input type="date" id="edit-death" class="grave-date-input">
      </div>
    </div>

    <textarea id="edit-text" rows="3" placeholder="${t('grave.epitaph')}" maxlength="500"></textarea>

    <div class="crea-field" style="margin: 12px 0; text-align: left;">
      <label class="grave-field-label">${t('pethernity.stylesLabel')}</label>
      <div class="style-picker" id="edit-style-picker" data-style="standard"></div>
    </div>

    <div style="margin-bottom: 12px; text-align: left;">
      <label class="grave-field-label">${t('grave.photoOptional')}</label>
      <input type="file" id="edit-photo-input" accept="image/*" style="font-size:12px; padding:8px; border-radius: 8px; background: rgba(255, 255, 255, 0.6);">
    </div>
    <div style="margin-bottom: 12px; text-align: left;">
      <label class="grave-field-label">${t('pethernity.galleryLabel')}</label>
      <p class="view-tributes-hint">${t('pethernity.galleryHint')}</p>
      <div id="edit-gallery-list" class="view-gallery"></div>
      <input type="file" id="edit-gallery-photo" accept="image/jpeg,image/png,image/webp" style="font-size:12px; padding:8px;">
      <input type="file" id="edit-gallery-video" accept="video/mp4,video/webm" style="font-size:12px; padding:8px;">
    </div>

    <button type="button" class="modal-btn" onclick="submitEditHeadstone()">${t('editHeadstone.save')}</button>
    <button type="button" onclick="closeEditHeadstoneModal()" class="secondary-modal-btn" style="margin-top:10px;">
      ${t('editHeadstone.cancel')}
    </button>
  </div>
</div>
`;
}

export function mountEditHeadstoneModal(): void {
  mountTemplate('edit-headstone-modal', buildEditHeadstoneTemplate());
}

export function remountEditHeadstoneModal(): void {
  resetEditFormBindings();
  mountEditHeadstoneModal();
}
